import { createDateRangePickerDriver } from '../date-range-picker/driver';
import { DateRangeCompareKey } from '.';
export var createDateRangeCompareDriver = function (wrapper) {
    var base = wrapper.$("." + DateRangeCompareKey);
    var rangePicker = function () { return createDateRangePickerDriver(base); };
    return {
        rangeStartDay: function () { return rangePicker().rangeStartDay(); },
        rangeEndDay: function () { return rangePicker().rangeEndDay(); },
        clickDay: function (day) { return rangePicker().clickDay(day); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map